module.exports = __webpack_public_path__ + "img/skechers_sila_2-0.6fe3b19a.svg";